<template>
  <div class="medida">
    <input-comp label="Medida" v-model="medida" />
  </div>
</template>

<script>
  import InputComp from "../../../../Componentes_Globales/Input/inputComp";

  export default {
    name: "Medida",
    components: {InputComp},
    computed: {
      medida: {
        get() {
          return this.$store.state.producto.producto.medida
        },
        set(value) {
          this.$store.commit("producto/SET_KEY_PRODUCTO", {key: "medida", value})
        }
      }
    }
  }
</script>

<style scoped>

</style>
